var modules_67e042e7 = {"cell":"Head_module_cell__87074b51","icons":"Head_module_icons__87074b51","pointer":"Head_module_pointer__87074b51"};
import "../../../assets/esm/components/Table/src/Head~CbTWLE5c.css";

export { modules_67e042e7 as default };
//# sourceMappingURL=Head.module.less.js.map
